import React, { ReactElement, FC, CSSProperties } from 'react'
import { Button } from 'antd'
import { BsChevronContract, BsChevronExpand } from 'react-icons/bs'

const s = {
  root: {
    display: 'flex',
  } as CSSProperties,
  icon: {
    margin: 'auto',
  } as CSSProperties,
}

interface ExpandCollapseChevronButtonProps {
  expanded: boolean
  handleExpandCollapse: () => void
}

export const ExpandCollapseChevronButton: FC<ExpandCollapseChevronButtonProps> = ({
  expanded,
  handleExpandCollapse,
}): ReactElement => (
  <Button
    type='text'
    style={s.root}
    onClick={handleExpandCollapse}
    icon={expanded ? <BsChevronContract style={s.icon} /> : <BsChevronExpand style={s.icon} />}
  />
)
